<template>
<div>
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
    width="70%"
     v-dialogDrag
    :visible.sync="visible">
    <el-form :model="inputForm" size="small" ref="inputForm" v-loading="loading" :class="method==='view'?'readonly':''"  :disabled="method==='view'"
             label-width="120px">
      <el-row   type="flex" style="flex-wrap:wrap;">
        <el-col :span="24">
          <el-divider content-position="left">UM前台显示的基本信息</el-divider>
        </el-col>
        <el-col :span="12">
            <el-form-item label="名称（英）:" prop="nameEn" :rules="[
                  {required: true, message:'名称（英）不能为空', trigger:'blur'}
                 ]">
              <!-- <span>{{ inputForm.nameEn }}</span> -->
              <el-input v-model="inputForm.nameEn"  placeholder="请填写名称（英）"  maxlength="64" ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="名称（中）:" prop="">
              <el-input v-model="inputForm.nameCn"  placeholder="请填写名称（中）"  maxlength="64" ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="空间类型" prop="positionId"
                :rules="[
                  {required: true, message:'空间类型不能为空', trigger:'blur'}
                 ]">
                 <div class="flex-row ai-center">
                 <el-select v-model="inputForm.positionId" placeholder="请选择" @change="handPosition"  style="width: 100%;">
                    <el-option
                      v-for="item in $dictUtils.getDictList('cec_um_space')"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <!-- <el-tooltip class="item ml8" effect="dark" content="空间类型指的是" placement="top">
                    <i class="el-icon-info"></i>
                  </el-tooltip> -->
                 </div>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="预估价格" prop="price"
                :rules="[
                  {required: true, message:'预估价格不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.price" placeholder="请填写" @input="handleInput($event,'price')"  @focus="focusInput($event,'price')" @blur="blurInput($event,'price')" ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="状态" prop="state"
                :rules="[
                  {required: true, message:'状态不能为空', trigger:'blur'}
                 ]">
                <el-select v-model="inputForm.state" placeholder="请选择"  style="width: 100%;">
                          <el-option
                            v-for="item in stateOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                      </el-select>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="项目数量" prop="num"
                :rules="[
                 ]">
              <el-input v-model.number="inputForm.num" placeholder="请填写项目数量"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="标签" prop=""
            :rules="[
              ]">
              <tagSelect ref="tagSelectRef" :value="inputForm.tagsIds" @searchChange="handSelect" @addTagCloud="addTagCloud" associationType="3"></tagSelect>
            </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="简介（英）:" prop="introductionEn"
                :rules="[
                  {required: true , message:'简介不能为空', trigger:'blur'}
                 ]">
              <el-input type="textarea" :autosize="{ minRows: 5 }" v-model="inputForm.introductionEn" placeholder="请填写简介内容"  maxlength="255"   ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="简介（中）:" prop=""
                :rules="[
                 ]">
              <el-input type="textarea" :autosize="{ minRows: 5 }" v-model="inputForm.introductionCn" placeholder="请填写简介内容"     maxlength="255" ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="24" class="rawStyle">
          <el-row   type="flex" style="flex-wrap:wrap;">
            <el-col :span="24">
              <el-divider content-position="left">后台相关关联信息</el-divider>
            </el-col>
            <el-col :span="12">
                <el-form-item label="关联套餐" prop="projectSetsId"
                    :rules="[
                      {required: true, message:'关联套餐不能为空', trigger:'blur'}
                    ]">
                    <div class="flex-row ai-center">
                  <el-select v-model="inputForm.projectSetsId" filterable placeholder="请选择关联套餐" style="width: 100%;" @change="handSets">
                      <el-option
                        v-for="item in dataList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                    <el-tooltip class="item ml8" effect="dark" content="用于关联套餐空间" placement="top">
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="关联套餐空间" prop="setsPositionId"
                    :rules="[
                      {required: true, message:'关联套餐空间不能为空', trigger:'blur'}
                    ]">
                    <div class="flex-row ai-center">
                  <el-select v-model="inputForm.setsPositionId" filterable @change="handPositionSets" placeholder="请选择关联套餐空间" style="width: 100%;">
                      <el-option
                        v-for="item in dataPostionList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                    <el-tooltip class="item ml8" effect="dark" content="用于关联配置空间项目可添加项目" placement="top">
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="24">
            <el-form-item label="功能空间:" prop="functionSpacePositionIds"
                :rules="[
                  {required: true, message:'功能空间不能为空', trigger:'blur'}
                 ]">
          <GridSelect
            ref="gridselectRef"
            title="选择功能空间"
            labelName = 'nameEn'
            :disabled="method==='view'"
            showType="table"
            labelValue = 'id'
            :value = "inputForm.functionSpacePositionIds"
            :limit="10"
            @getValue='(value) => {inputForm.functionSpacePositionIds=value}'
            :columns="[
            {
              prop: 'nameCn',
              label: '中文名称'
            },
            {
              prop: 'nameEn',
              label: '英文名称'
            }
            ]"
            :searchs="[
            {
              prop: 'nameCn',
              label: '中文名称'
            },
            {
              prop: 'nameEn',
              label: '英文名称'
            }
            ]"
            dataListUrl="/unmspace/cecUnmFunctionalSpace/list"
            queryEntityUrl="/unmspace/cecUnmFunctionalSpace/queryById">
          </GridSelect>
          <div style="font-size: 12px;">* 功能空间，用于UM空间详情</div>
           </el-form-item>
        </el-col>
        <el-col :span="24" :class="inputForm.showGallery == '0' ? 'opacity5' : ''">
            <el-form-item label="展览集:" prop="gallery"
                :rules="[
                  {required: inputForm.showGallery == '1' ? true : false , message:'展览集不能为空', trigger:'change'}
                 ]">
                <ImageUploadDraggableBtn
                  v-model="inputForm.gallery"
                  :draggable="true"
                  :itemActivityForm="true"
                  :ifSetUploadName="true" 
                  :ownerId="inputForm.id"
                  :uploadInfo="{type:'postionImage',title:'展览集' ,category: 'sets',categoryName: '套餐空间',tip:'请先输入英文名称',fileName: inputForm.nameEn}"
                  :disabled="false"
                  action="/unmfile/cecUnmFileupload"
                  tip="单个图片不要超过10M,可拖动列表行排序"
                  @updateChange="handImageList($event,'gallery')">
                </ImageUploadDraggableBtn>
                <div style="font-size: 12px;">* 展览集，用于UM空间详情，展览相关内容， 默认首张图片为列表封面</div>
           </el-form-item>
        </el-col>
        </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="medium" type="danger"  icon="el-icon-close" @click="visible = false">关闭</el-button>
      <el-button size="medium" type="success" icon="el-icon-check" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
  import cecUnmPositionService from '@/api/cecunmposition/cecUnmPositionService'
  import cecUnmProjectPositionService from '@/api/unmprojectposition/cecUnmProjectPositionService'
  import cecUnmSetsService from '@/api/unmsets/cecUnmSetsService'
  import GridSelect from '@/components/gridSelect/setTagTableSet.vue'
  import ImageUploadDraggableBtn from '@/components/upload/ImageUploadDraggableBtn'
  import tagSelect from '@/components/select/tagSelect'
  import _ from 'lodash'
  export default {
    data () {
      return {
        title: '',
        method: '',
        visible: false,
        loading: false,
        tagList: [],
        inputForm: {
          id: '',
          nameEn: '',
          nameCn: '',
          num: '',
          targetPrice: '',
          sort: '',
          type: '',
          functionalSpaceIds: '',
          functionSpacePositionIds: '',
          gallery: [],
          introductionCn: '',
          introductionEn: '',
          tag: [],
          tagsIds: '',
          projectSetsId: '',
          setsPositionId: '',
          positionId: '',
          price: '',
          state: ''
        },
        tablePage: {
          total: 0,
          currentPage: 1,
          pageSize: 100,
          orders: [{ column: 'sort', asc: false }]
        },
        dataList: [],
        dataPostionList: [],
        stateOption: [
          { value: '0', label: '上线' },
          { value: '2', label: '草稿' },
          { value: '1', label: '下线' }
        ]
      }
    },
    components: {
      GridSelect,
      ImageUploadDraggableBtn,
      tagSelect
    },
    methods: {
      handPosition (e) {
        if (this.inputForm.setsPositionId) {
          let findPositionName = this.$dictUtils.getDictList('cec_um_space').find(item => item.value === e).label
          console.log(this.$dictUtils.getDictList('cec_um_space'))
          let findSetsPositionName = this.dataPostionList.find(item => item.value === this.inputForm.setsPositionId).label
          if (this.hasMatchingField(findSetsPositionName, findPositionName)) {
            this.validateSpaceType('positionId', '', 'success')
            this.validateSpaceType('setsPositionId', '', 'success')
          } else {
            this.validateSpaceType('positionId', '与关联套餐空间不符', 'error')
          }
        }
      },
      handPositionSets (e) {
        if (this.inputForm.positionId) {
          let findSetsPositionName = this.dataPostionList.find(item => item.value === e).label
          let findPositionName = this.$dictUtils.getDictList('cec_um_space').find(item => item.value === this.inputForm.positionId).label
          if (this.hasMatchingField(findSetsPositionName, findPositionName)) {
            this.validateSpaceType('setsPositionId', '', 'success')
            this.validateSpaceType('positionId', '', 'success')
          } else {
            this.validateSpaceType('setsPositionId', '与空间类型不符', 'error')
          }
        }
      },
      // 单独触发空间类型的校验
      validateSpaceType (propName, msg, state) {
        // 如果校验不通过，显示自定义错误提示
        this.$refs.inputForm.fields.find((field) => field._props.prop === propName).validateMessage = msg
        this.$refs.inputForm.fields.find((field) => field._props.prop === propName).validateState = state
        //   // 校验通过
        //   this.$refs.inputForm.fields.find((field) => field._props.prop === 'positionId').validateMessage = '空间类型不符' 'error'
        //   this.$refs.inputForm.fields.find((field) => field._props.prop === 'setsPositionId').validateState = ''
      },
      // 对比两个字符是否相似
      hasMatchingField (name1, name2) {
        const lowerName1 = name1.toLowerCase()
        const lowerName2 = name2.toLowerCase()
        return lowerName1.includes(lowerName2) || lowerName2.includes(lowerName1)
      },
      addTagCloud () {
        this.$emit('addTagCloud')
      },
      /** 输入框变化 */
      handleInput (value, type) {
        if (value === '') return
        const regex = /^\d+(\.\d*)?$/ // 使用正则表达式匹配 正整数 或小数点位数不限制的浮点数
        let formattedValue = value
        // 如果输入值不符合正则表达式，则将其设置为上一个有效值
        if (!regex.test(value)) {
          formattedValue = value.replace(/,/g, '').replace(/\D/g, '')
          // this.inputForm[type] = value.slice(0, value.length - 1)
          // this.handleInput(this.inputForm[type], type)
        }
        this.inputForm[type] = formattedValue
      },
      /** 输入框获得焦点 */
      focusInput (e, type) {
        if (e) return
        const val = e
        this.inputForm[type] = this.moneyToNumber(val) // 千分位转数值
      },
      /** 输入框失去焦点 */
      blurInput (e, type) {
        let val = e.target.value
        val = !val ? '' : Number(val)
        this.inputForm[type] = this.formateMoney(val) // 数值转为千分位格式
      },
      formateMoney (number) {
        return number.toLocaleString('zh-CN')
      },
      moneyToNumber (str) {
        // 使用正则表达式去除千分位分隔符（逗号）
        const cleanStr = str.replace(/,/g, '')
        // 将清理后的字符串转换为数值类型
        const number = parseFloat(cleanStr)
        return number
      },
      handSelect (e) {
        this.inputForm.tagsIds = e ? e.join(',') : ''
      },
      // 上传返回ids
      handImageList: _.debounce(function (e, type) {
        const that = this
        that.inputForm[type] = e.map(item => {
          let ritem = {
            // id: item.percentage === 0 ? '' : item.id,
            fileName: item.fileName,
            name: item.name,
            fileSize: item.size ? item.size : item.fileSize,
            url: item.url,
            filePath: item.filePath ? item.filePath : item.url,
            category: item.category ? item.category : 'setsMealPostion_' + type,
            description: item.description ? item.description : '',
            actorId: item.actorId,
            actorName: item.actorName,
            categoryName: item.categoryName,
            startTime: item.startTime,
            createDate: item.createDate,
            pixel: item.pixel
          }
          return ritem
        })
      }, 500),
      handSets (e) {
        this.getSetsPositionList(e)
      },
      // 获取关联套餐空间列
      async getSetsPositionList (id, setsPositionId) {
        await cecUnmProjectPositionService.allList({
          projectSetsId: id,
          grade: '2',
          orders: [{ column: 'sort', asc: true }]
        }).then(({data}) => {
          this.dataPostionList = data.map(item => {
            let query = {
              value: item.id,
              label: item.nameCn
            }
            return query
          })
          if (setsPositionId) {
            this.inputForm.setsPositionId = setsPositionId
          }
        })
      },
      // 获取关联套餐列表
      getSetsList () {
        this.loading = true
        cecUnmSetsService.list({
          'current': this.tablePage.currentPage,
          'size': this.tablePage.pageSize,
          'orders': this.tablePage.orders
        }).then(({data}) => {
          let setList = data.records.map(item => {
            let query = {
              value: item.id,
              label: item.nameCn
            }
            return query
          })
          this.dataList = setList
        })
      },
      init (method, id) {
        this.getSetsList()
        this.method = method
        this.inputForm.id = id
        if (method === 'add') {
          this.title = `新建UM空间`
        } else if (method === 'edit') {
          this.title = '修改UM空间'
        } else if (method === 'view') {
          this.title = '查看UM空间'
        }
        this.visible = true
        this.loading = false
        this.$nextTick(() => {
          this.clearForm()
          if (method === 'edit' || method === 'view') { // 修改或者查看
            this.loading = true
            cecUnmPositionService.queryById(this.inputForm.id).then(({data}) => {
              this.getSetsPositionList(data.projectSetsId, data.setsPositionId)
              this.inputForm = this.recover(this.inputForm, data)
              this.inputForm.setsPositionId = ''
              this.loading = false
            })
          }
        })
      },
      clearForm () {
        this.$refs.tagSelectRef.getTagCloud()
        this.$refs.inputForm.resetFields()
        this.inputForm.tagsIds = ''
        this.inputForm.nameCn = ''
        this.inputForm.introductionCn = ''
        this.inputForm.gallery = []
      },
      // 表单提交
      doSubmit () {
        this.inputForm.functionSpacePositionIds = this.$refs.gridselectRef.withoutList.map(item => item.id).join(',')
        this.$refs['inputForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            cecUnmPositionService.save(this.inputForm).then(({data}) => {
              this.visible = false
              this.$message.success(data)
              this.$emit('refreshDataList')
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }
        })
      }
    }
  }
</script>
<style scoped>
::v-deep .el-dialog__body{
 padding: 10px 20px !important;
}
::v-deep .el-tag:first-child{
  margin-left: 5px;
  
}
.rawStyle{
  border-radius: 2px;
  padding: 5px;
  border: 1px solid #dcdfe6;
  margin-bottom: 10px;
}
</style>
  
